export default { getRegionFromUrl };

function getRegionFromUrl() {
  const url = window.location.href;
  if (url.includes("uk.mitimes")) {
    return 'eu';
  }
  return 'au';
}
